import { post, get } from 'utils/api';
import { DataResponse } from './response';

export type MCCommandModel = {
  stt: number;
  matchCardCommandId: string;
  matchCardCode: string;
  printItem: string;
  designVote: string;
  designBy: string;
  printStyle: string;
  printCompany: string;
  zincSupplier: string;
  documentDate: string;
  printReqDate: string;
  workOrderCode: string;
  productCode: string;
  productName: string;
  deliveryDate: string;
  isMatchCard: boolean;
  poCode: string;
  workOrderMesStatus: string;
  workOrderNetsuiteStatus: string;
} & Record<string, any>;

export type WorkOrderMCsModel = {
  workOrderCode: string;
  productCode: string;
  productName: string;
  workOrderRoutings: WorkOrderRoutings[];
};

export type SearchMCCommand = {
  paging: {
    pageIndex: number;
    pageSize: number;
  };
} & Partial<{
  matchCardCode: string;
  printItem: string;
  designVote: string;
  printCompany: string;
  fromDocumentDate: string;
  toDocumentDate: string;
  fromPrintReqDate: string;
  toPrintReqDate: string;
  // trạng thái netsuite
  netsuiteStatus: string;
  // Trạng thái mes
  mesStatus: string;
  isMatchCard: string;
}>;

export type WorkOrderRoutings = {
  orderIndex: number;
  stepCode: string;
  stepName: string;
  productionGuide: string;
  productPerPage: number;
  productPerStep: number;
  unit: string;
  totalQuantity: number;
  estimateComplete: number;
  setupTime: number;
  ratedTime: number;
  matchCard: boolean;
  rated: number;
  componentUsed: string;
  mold?: string;
};

export type RoutingRates = {
  isEdit: boolean;
  orderIndex?: number;
  stepCode: string;
  stepName: string;
  workOrderRates: workOrderRates[];
};
export type workOrderRates = {
  workOrderId: string;
  workOrderCode: string;
  productPerPage: number;
  matchCard: boolean;
  rated: number;
  isDisable: boolean;
};

export type MCCommandDetailModel = {
  matchCardCode: string;
  printItem: string;
  workOrderCodes: string;
  printCompany: string;
  designVote: string;
  printReqDate: string;
  workOrderMCs: WorkOrderMCsModel[];
  routingRates: RoutingRates[];
};

export type MCCommandResponse = {
  data: Array<MCCommandModel>;
  message: string;
  isSuccess: boolean;
  paging: {
    totalCount: number;
    totalPage: number;
    pageSize: number;
  };
};
export type MCCommandDetailResponse = {
  data: MCCommandDetailModel;
  message: string;
  isSuccess: boolean;
  resultsCount: number;
  recordsTotal: number;
  pagesCount: number;
};

export interface IMCCommandServices {
  getListMCCommand(data: any): Promise<MCCommandResponse>;
  getMCCommandDetail(id: string): Promise<MCCommandDetailResponse>;
  updateMCWORouting(data: any): Promise<DataResponse<any>>;
}

export function createMCCommandServices(): IMCCommandServices {
  return {
    getListMCCommand: async (data) => {
      return (await post(`MasterData/MCCommand/get-list-match-card`, data)).data;
    },
    getMCCommandDetail: async (id) => {
      return (await get(`MasterData/MCCommand/get-details-match-card?MCCommandId=${id}`)).data;
    },

    updateMCWORouting: async (data) => {
      return (await post(`MasterData/WorkOrder/update-mc-wo-routing`, data)).data;
    },
  };
}
